<template>
  <div>
    <popup-warp :value="value" @input="onInput">
      <div class="select-network-top">
        <span class="select-btn" @click="onInput(false)">{{$t('msg.cancel')}}</span>
        <span class="select-title">{{$t('confirm.select_network')}}</span>
        <span class="select-btn" @click="onSelect">{{$t('msg.confirm')}}</span>
      </div>
      <select-column @select="isSelect" :values="values"></select-column>
    </popup-warp>
  </div>
</template>

<script>
import { PopupWarp } from '../popup'
import SelectColumn from './column'
// 赞比亚移动运营商(Flutterwave mobile_money_zambia)
const networks = [
  { label: 'MTN', value: 'MTN' },
  { label: 'Airtel', value: 'AIRTEL' },
  { label: 'Zamtel', value: 'ZAMTEL' }
]
export default {
  name: 'SelectNetwork',
  components: {
    PopupWarp,
    SelectColumn
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tempVal: networks[0],
      values: networks
    }
  },
  methods: {
    onInput (val) {
      this.$emit('input', val)
    },
    onSelect () {
      this.$emit('select', this.tempVal)
      this.$emit('input', false)
    },
    isSelect (val) {
      this.tempVal = val
    }
  }
}
</script>

<style lang="less" scoped>
.select-network-top {
  color: #00ce70;
  font-size: 32px;
  line-height: 80px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  .select-btn {
    padding: 0 18px;
  }
  .select-title {
    flex: 1;
    font-size: 28px;
    text-align: center;
    color: #333;
  }
}
</style>
